export default {
    archived: [{
            text: "Credor",
            value: "creditor.name",
            width: "10%",
            sortable: false,
        },
        {
            text: "Estratégia",
            align: "left",
            value: "id",
        },
        {
            text: "Abordagem",
            align: "left",
            width: "30%",
            sortable: false,
        },
        {
            text: "Aquivado",
            align: "left",
            value: "updated_at",
            width: "10%",
        },
        {
            text: "Ações",
            align: "center",
            width: "1%",
            sortable: false,
        },
    ],
    strategy: [{
            text: "Estratégia",
            tooltip: "Estratégia",
            align: "left",
            value: "name",
            width: "35%",
        },
        {
            text: "Segmento",
            tooltip: "Faixa de atraso e faixa de valor por tipo de débito Principal(P), Neogocição(N), Risco(R)",
            align: "left",
            value: "segmentString",
            width: "25%",
        },
        {
            text: "Qualidade",
            tooltip: "Qualidade do contato",
            align: "left",
            value: "contact_max_final_score",
            width: "10%",
        },
        {
            text: "Notificação",
            tooltip: "Notificação",
            align: "left",
            value: "max_notifications",
            width: "10%",
        },
        {
            text: "Disparo",
            tooltip: "Dados do último disparo",
            align: "left",
            value: "last_notified_at",
            width: "5%",
        },
        {
            text: "Importação",
            tooltip: "Importado à partir de",
            align: "left",
            value: "last_import_since",
            width: "5%",
        },
        {
            text: "Atualizada",
            tooltip: "Data da última atualização",
            align: "left",
            value: "updated_at",
            width: "9%",
        },
        {
            text: "Ações",
            tooltip: "Ações",
            value: "action",
            align: "center",
            width: "1%",
            sortable: false,
        },
    ],
    strategyImported: [{
            text: "Estratégia",
            tooltip: "Estratégia",
            align: "left",
            value: "name",
            width: "35%",
        },
        {
            text: "Segmento",
            tooltip: "Faixa de atraso e faixa de valor por tipo de débito Principal(P), Neogocição(N), Risco(R)",
            align: "left",
            value: "segmentString",
            width: "30%",
        },
        {
            text: "Qualidade",
            tooltip: "Qualidade do contato",
            align: "left",
            value: "contact_max_final_score",
            width: "10%",
        },
        {
            text: "Disparo",
            tooltip: "Dados do último disparo",
            align: "left",
            value: "last_notified_at",
            width: "10%",
        },
        {
            text: "Importação",
            tooltip: "Importado à partir de",
            align: "left",
            value: "last_import_since",
            width: "5%",
        },
        {
            text: "Atualizada",
            tooltip: "Data da última atualização",
            align: "left",
            value: "updated_at",
            width: "9%",
        },
        {
            text: "Ações",
            tooltip: "Ações",
            value: "action",
            align: "center",
            width: "1%",
            sortable: false,
        },

    ],
    strategyLocated: [{
            text: "Estratégia",
            tooltip: "Estratégia",
            align: "left",
            value: "name",
            width: "35%",
        },
        {
            text: "Segmento",
            tooltip: "Faixa de atraso e faixa de valor por tipo de débito Principal(P), Neogocição(N), Risco(R)",
            align: "left",
            value: "segmentString",
            width: "25%",
        },
        {
            text: "Qualidade",
            tooltip: "Qualidade do contato",
            align: "left",
            value: "contact_max_final_score",
            width: "10%",
        },
        {
            text: "Notificação",
            tooltip: "Notificação",
            align: "left",
            value: "max_notifications",
            width: "10%",
        },
        {
            text: "Disparo",
            tooltip: "Dados do último disparo",
            align: "left",
            value: "last_notified_at",
            width: "5%",
        },
        {
            text: "Importação",
            tooltip: "Importado à partir de",
            align: "left",
            value: "last_import_since",
            width: "5%",
        },
        {
            text: "Atualizada",
            tooltip: "Data da última atualização",
            align: "left",
            value: "updated_at",
            width: "9%",
        },
        {
            text: "Ações",
            tooltip: "Ações",
            value: "action",
            align: "center",
            width: "1%",
            sortable: false,
        },
    ],

}